<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import ImageUpload from "../../../components/widgets/ImageUpload.vue"

/**
 * Starter component
 */
export default {
  page: {
    title: "Products",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader,ImageUpload },
  data() {
    return {
      title: "Products",
      imagePriview:"",
      image:null,
      name : "",
      total : "",
      id : "",
      breadcumbs: [
        {
          text: "Products",
          active: true
        }
      ]
    };
  },
  computed: {
    items() { return this.$store.getters['product/items'] },
    item() { return this.$store.getters['product/item'] },
    state() { return this.$store.getters['product/state'] },
    loading() { return this.$store.getters['product/loading'] },
    message() { return this.$store.getters['product/message'] },
    error() { return this.$store.getters['product/error'] },
    sponsors() { return this.$store.getters['product/sponsors'] },
  },
  mounted(){
    this.$store.dispatch("product/get")
    //   this.getSoals();
  },
  methods:{
    reset(){
        this.name = "";
        this.total = "";
        this.id = "";
    },
    showCreate(){
          this.reset();
          this.$store.commit("product/SET_STATE","CREATE")
    },
    showList(){
        this.reset();
        this.$store.commit("product/SET_STATE","LIST")
    },
    save(){
      var param = {
          name : this.name,
          total : this.total
      }
      this.$store.dispatch("product/create",param)
      this.reset();
    },
    edit(data){
        this.reset();
        this.name = data.name
        this.total = data.total
        this.id = data.id
        this.$store.commit("product/SET_STATE","EDIT")
    },
    update(){
      var param = {
          name : this.name,
          total : this.total,
          id : this.id,
      }
      this.$store.dispatch("product/edit",param)
      this.reset();
    },
    showSponsor(id){
        this.$store.dispatch("product/sponsors_lists",id)
        .then(()=>{
          this.$root.$emit('bv::show::modal', 'modal-sponsors', '#focusThisOnClose')
        })
    },
    showModal(id){
      this.id = id
      this.$root.$emit('bv::show::modal', 'modal-1', '#focusThisOnClose')
    },
    handleUpload(){
      let formdata = new FormData();
      if(this.image != null){
        formdata.append('image',this.image)
        formdata.append('product_id',this.id)
        this.$store.dispatch("product/save",formdata)
        Swal.fire("Uploaded!", "Sponsor Berhasil di tambahkan.", "success");
      }
    },
    confirm(id) {
        this.reset();
      Swal.fire({
        title: "Apakah Anda Yakin ?",
        text: "Data Yang Di hapus Tidak dapat di kembalikan!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ya, Hapus !"
      }).then(result => {
        if (result.value) {
          this.$store.dispatch("product/delete",id);
          Swal.fire("Deleted!", "Berhasil Data Akan Segera Terhapus.", "success");
        }else{
          Swal.fire("Cancel!", "Data Tidak Terhapus", "error");
        }
      });
    },
  }
};
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="breadcumbs" />
      <div class="row">
        <div class="col-md-12">
            <b-alert show dismissible fade v-show="message != ''">{{message}}</b-alert>
        </div>
        <!-- start list -->
        <div class="col-md-12" v-if="state == 'LIST'">
          <button class="btn btn-pill btn-primary mb-2" @click="showCreate()"> <i class="bx bx-user-plus"></i> Tambah Data Products</button>
          <div class="card">
            <div class="card-body">
              <h4 class="card-title">Data Products</h4>
              <div class="table-responsive">
                <table class="table table-striped table-hover">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Total</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="list in items" :key="list.id">
                      <td>{{list.name}}</td>
                      <td>{{list.total}}</td>
                      <td>
                          <button class="btn btn-danger btn-sm  mx-1" @click="confirm(list.id)" v-b-tooltip.hover title="Delete" ><i class="bx bx-trash"></i></button>
                          <button class="btn btn-success btn-sm mx-1" @click="showModal(list.id)">Add Sponsor</button>
                          <button class="btn btn-info btn-sm mx-1" @click="showSponsor(list.id)">View Sponsor</button>
                          
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>

        <b-modal id="modal-1" title="Add Sponsor" @ok="handleUpload">
          <ImageUpload :refid="`image`" :onChangeImage="(image)=>this.image=image" :imgDefault="imagePriview"/>
        </b-modal>
        <b-modal id="modal-sponsors" title="Lists Sponsors" size="xl">
          <div class="row">
            <div class="col-md-4" v-for="img in sponsors" :key="img.id">
              <img :src="`https://admin-api.peanutbutterevents.com/storage/images/${img.name}`" alt="sponsors" width="100%" height="100%">
            </div>
          </div>
        </b-modal>
        <!-- end list -->
        <!-- start create -->
          <div class="col-md-12" v-if="state == 'CREATE'">
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">Create New Products</h4>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="form-group">
                        <label for="name" class="control-label">Products Name <span class="text-danger">*</span></label>
                        <input type="text" class="form-control" v-model="name" id="name" placeholder="Products Name *">
                      </div>
                      <div class="form-group">
                        <label for="phone" class="control-label">Total</label>
                        <input type="text" class="form-control" v-model="total" id="total" placeholder="Total">
                      </div>
                    </div>
                  </div>
              </div>
              <div class="card-footer">
                <button class="btn btn-danger btn-sm mx-1" @click="showList()"  v-b-tooltip.hover title="Cancel"><i class="bx bx-left-arrow-alt"></i> Cancel</button>
                <button class="btn btn-info btn-sm  mx-1" @click="save()" :disabled="loading" v-b-tooltip.hover title="Save" ><i v-if="loading" class="bx bx-loader-circle"></i> <i v-else class="bx bxs-cloud-upload"></i> Save</button>
              </div>
            </div>
          </div>
        <!-- end create -->
      </div>
  </Layout>
</template>